var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcAboutCardIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9675 12.8329H31.6863V10.5526H11.4431V30.7958H13.7244V33.077H9.16187V8.27136H33.9675V12.8329ZM27.1248 5.99011H24.8435V3.70886H4.60034V23.952H6.88062V26.2343H2.31909V1.42859H27.1248V5.99011Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    d: "M28.2651 14.7396C28.3069 14.739 33.8561 14.6703 34.8228 20.1986V26.2338H37.6743V36.7836C37.6741 38.3581 36.3972 39.6341 34.8228 39.6342H21.4224C19.8479 39.6342 18.571 38.3581 18.5708 36.7836V26.2338H21.4224V20.7728C21.423 20.7597 21.695 15.0802 28.2651 14.7396ZM27.98 16.7504C27.98 16.7504 23.9679 16.8522 23.7026 21.0599V26.2338H32.8267V20.4857C32.8267 20.4857 31.809 16.9 27.98 16.7504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcAboutCardIcon1);
export default __webpack_public_path__ + "static/media/xdc-about-card-icon-1.3fec2403921b499a37260b221ae7466b.svg";
export { ForwardRef as ReactComponent };